export default "__VITE_ASSET__1c75d6d8__"